import { FC, useContext } from "react";

import * as cols from "components/ListingTable/setupColumns";
import { BaseListings } from "containers";
import { AppContext } from "contexts";
import * as routes from "routes";

import {
  makeDefaultUiParams,
  validDynamicRestUrlParams,
  validUiSortOptions,
} from "./filters/constants";
import { buildFilters } from "./filters";

const OpenListings: FC = () => {
  const { user } = useContext(AppContext);
  const userId = user?.userId;

  return (
    <BaseListings
      buildFilters={buildFilters}
      makeDefaultUiParams={makeDefaultUiParams}
      validDynamicRestUrlParams={validDynamicRestUrlParams}
      validUiSortOptions={validUiSortOptions}
      desktopColumns={
        !!userId
          ? cols.desktopOpenListingsAuthenticated
          : cols.desktopOpenListingsAnonymous
      }
      mobileColumns={cols.mobileOpenListings}
      headerContent={{
        h1Content: { default: "The Exchange" },
        subtitle1Content:
          "Join 30,000 registered investors and make offers directly on hundreds of royalty assets — from hit songs to trademark royalties.",
        headerButtonContent: {
          label: "Past Deals",
          path: routes.orderBookPastDeals(userId),
        },
      }}
      title="Open Listings"
      baseUrl={routes.orderBookOpenListingsNoParams()}
      showAcceptingFinalOffersSection
    />
  );
};

export default OpenListings;
